module.exports = __webpack_public_path__ + "static/media/google-sheets-white.71bf7ea7.svg";